// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2IyAy","insightsList":"newBusinessInsightsMenu_insightsList__2ze2K","active":"newBusinessInsightsMenu_active__v1qjZ"};